// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-manager {
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #1e1e1e;
  padding: 0 1vh;
}

.tab-headers {
  display: flex;
  border-bottom: 1px solid #3e3e42;
  overflow-x: auto;
  flex-shrink: 0;
  padding-left: 20vh;
}

.tab-header {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  background: #1e1e1e;
  border-left: 1px solid #3e3e42;
  border-right: 1px solid #3e3e42;
  transition: background 0.2s;
  white-space: nowrap;
  min-width: 120px;
  max-width: 250px;
  color: #cccccc80;
}

.tab-header:hover {
  background: #37373d;
}

.tab-header.active {
  background: #3e3e42;
  color: #cccccc;
}

.tab-title {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.tab-close {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  margin-left: 8px;
  cursor: pointer;
  color: #999;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: all 0.2s;
}

.tab-close:hover {
  background: #505050;
  color: #fff;
}

.tab-content-container {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  background: #1e1e1e;
}

.tab-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  overflow: hidden;
  background: #1e1e1e;
}

.tab-content.active {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/TabManager.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".tab-manager {\n  height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #1e1e1e;\n  padding: 0 1vh;\n}\n\n.tab-headers {\n  display: flex;\n  border-bottom: 1px solid #3e3e42;\n  overflow-x: auto;\n  flex-shrink: 0;\n  padding-left: 20vh;\n}\n\n.tab-header {\n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  cursor: pointer;\n  background: #1e1e1e;\n  border-left: 1px solid #3e3e42;\n  border-right: 1px solid #3e3e42;\n  transition: background 0.2s;\n  white-space: nowrap;\n  min-width: 120px;\n  max-width: 250px;\n  color: #cccccc80;\n}\n\n.tab-header:hover {\n  background: #37373d;\n}\n\n.tab-header.active {\n  background: #3e3e42;\n  color: #cccccc;\n}\n\n.tab-title {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 8px;\n}\n\n.tab-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  line-height: 1;\n  padding: 0;\n  margin-left: 8px;\n  cursor: pointer;\n  color: #999;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  transition: all 0.2s;\n}\n\n.tab-close:hover {\n  background: #505050;\n  color: #fff;\n}\n\n.tab-content-container {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  background: #1e1e1e;\n}\n\n.tab-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: none;\n  overflow: hidden;\n  background: #1e1e1e;\n}\n\n.tab-content.active {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
